module.exports = __webpack_public_path__ + "static/img/KR.d7cba5c2.svg";